
<!-- list -->
<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">

                <div class="tools">

                    <div class="left-buttons">

                        <!-- select action -->
                        <div ngbDropdown class="d-inline-block" *ngIf="countSelectedFiles">

                            <button type="button" class="btn btn-primary btn-sm" id="dropdown" ngbDropdownToggle>
                                Выберите действие <span> ({{ countSelectedFiles }}) </span> 
                            </button>

                            <div ngbDropdownMenu aria-labelledby="dropdown">
                                <button ngbDropdownItem (click)="obligation('true')"> Сделать обязательным </button>
                                <button ngbDropdownItem (click)="obligation('false')"> Сделать необязательным </button>
                            <hr>
                            <button *ngIf="attribute_type" ngbDropdownItem class="btn-delete" (click)="deleteSelected()"> Удалить </button>
                           
                            </div>
                        </div>

                        <!-- filter -->
                        <button type="button" class="btn btn-primary btn-sm filter" (click)="filterFromAttribute()">
                            <svg-icon  src="/assets/images/icons/filter2.svg" [stretch]="true"
                            [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon> <span style="padding-top: 2px;">Фильтр</span>
                        </button>

                        <!-- reset filter settings -->
                        <button type="button" class="btn btn-castom btn-sm filter" (click)="resetFilterSettings()" *ngIf="filterParams">
                            <img src="/assets/images/icons/refresh.svg">
                        </button>
                    </div>

                    <div class="right-buttons">
    
                        <!-- add attribute -->
                        <button type="button" class="btn btn-primary btn-sm" (click)="actionWithAttribute()">
                            <i class="bi bi-plus-circle"></i> {{ 'ADD' | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="card-body">

                <table class="table table-hover">

                    <thead>
                        <tr>
                            <th scope="col" class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_attr_all"
                                        id="select_attr_all" [checked]="isAllCheckBoxChecked()"
                                        [indeterminate]="checkedButNotAllCheckBox()"
                                        (change)="checkAllCheckBox($event)">
                                    <label class="custom-control-label" for="select_attr_all"></label>
                                </div>
                            </th>
                            <th scope="col" class="name name-attr" (click)="sortData('name')">Наименование атрибута  
                                <div class="derection-arrow">
                                    <i *ngIf="checkDirection('name') == ''  || isEmptyObject(sort)"><img class="th-icon" src="/assets/images/icons/sort-arrow.svg"></i>
                                    <i *ngIf="checkDirection('name') == 'asc'"><img class="th-icon" src="/assets/images/icons/sort-asc.svg"></i>
                                    <i *ngIf="checkDirection('name') == 'desc'"><img class="th-icon" src="/assets/images/icons/sort-desc.svg"></i>
                                </div>
                            </th>
                            <th scope="col" class="name" (click)="sortData('attribute_group_id')"> Группа 
                                <div class="derection-arrow">
                                    <i *ngIf="checkDirection('attribute_group_id') == ''  || isEmptyObject(sort)"><img class="th-icon" src="/assets/images/icons/sort-arrow.svg"></i>
                                    <i *ngIf="checkDirection('attribute_group_id') == 'asc'"><img class="th-icon" src="/assets/images/icons/sort-asc.svg"></i>
                                    <i *ngIf="checkDirection('attribute_group_id') == 'desc'"><img class="th-icon" src="/assets/images/icons/sort-desc.svg"></i>
                                </div>
                            </th>
                            <th scope="col" class="name" (click)="sortData('attribute_value_type')"> Тип 
                                <div class="derection-arrow">
                                    <i *ngIf="checkDirection('attribute_value_type') == ''  || isEmptyObject(sort)"><img class="th-icon" src="/assets/images/icons/sort-arrow.svg"></i>
                                    <i *ngIf="checkDirection('attribute_value_type') == 'asc'"><img class="th-icon" src="/assets/images/icons/sort-asc.svg"></i>
                                    <i *ngIf="checkDirection('attribute_value_type') == 'desc'"><img class="th-icon" src="/assets/images/icons/sort-desc.svg"></i>
                                </div>
                            </th>
                            <th scope="col" class="name" (click)="sortData('attr_present_type_id')"> Формат 
                                <div class="derection-arrow">
                                    <i *ngIf="checkDirection('attr_present_type_id') == ''  || isEmptyObject(sort)"><img class="th-icon" src="/assets/images/icons/sort-arrow.svg"></i>
                                    <i *ngIf="checkDirection('attr_present_type_id') == 'asc'"><img class="th-icon" src="/assets/images/icons/sort-asc.svg"></i>
                                    <i *ngIf="checkDirection('attr_present_type_id') == 'desc'"><img class="th-icon" src="/assets/images/icons/sort-desc.svg"></i>
                                </div>
                            </th>
                            <th scope="col" class="toggle"> Шкала заполненности</th>
                            <th scope="col" class="action"></th>
                        </tr>
                    </thead>

                    <tbody *ngIf="attributes">
                        <tr *ngFor="let attribute of attributes; let i = index">
                            <td class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_attr_all{{ i }}"
                                        id="select_attr_all{{ i }}" [checked]="attribute.checked"
                                        (change)="selectedCheckBox(i, $event)">
                                    <label class="custom-control-label" for="select_attr_all{{ i }}"></label>
                                </div>
                            </td>
                            <td class="name"> {{ attribute.name }} </td>
                            <td class="name"> {{ attribute.attribute_group_id }} </td>
                            <td class="name"> {{ getAttrType(attribute.attribute_value_type) }} </td>
                            <td class="name"> {{ getAttrFormat(attribute.attr_present_type_id) }} </td>
                            <td class="toggle"> 

                                <!-- toggle -->
                                <label class="switch">
                                    <input type="checkbox" [(ngModel)]="attribute.scale" (change)="toggleChecked(attribute.id, $event)">
                                    <span class="slider round"></span>
                                </label>
                            </td>
                            <td class="action">
                                <div class="action-btn">
                                    <!-- btn unlock role -->
                                    <button type="button" class="btn btn-none"(click)="onEdit(attribute.id)" *ngIf="attribute.commercial" placement="left" tooltipClass="clue-name" ngbTooltip="{{ 'EDIT' | translate }}">
                                        <svg-icon class="" src="/assets/images/icons/edit.svg" [stretch]="true" [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                    </button>
    
                                    <!-- btn block role -->
                                    <button type="button" class="btn btn-none" (click)="deleteOneAttr(attribute.id)" *ngIf="attribute.commercial" placement="left"  tooltipClass="clue-name" ngbTooltip="{{ 'DELETE' | translate }}">
                                        <svg-icon class="" src="/assets/images/icons/delete.svg" [stretch]="true"[svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                                    </button>
    
                                    <!-- <section class="action-btn_list">
        
                                        <ng-template class="btn-list" #popContent>
    
                                            <div class="btn-list_item"
                                                (click)="onEdit(role.urole.id)">
                                                <span>{{ 'Редактировать' | translate }}</span>
                                            </div>
    
                                            <div class="list-item_delete"
                                                (click)="deleteOneRole(role.urole.id)">
                                                <span>{{ 'Удалить' | translate }}</span>
                                            </div>
    
                                        </ng-template>
    
                                        <button type="button" placement="left" [ngbPopover]="popContent"
                                            [autoClose]="true" triggers="manual" #p="ngbPopover"
                                            class="btn btn-none action-btn_active btn-sm"
                                            popoverClass="my-custom-class"
                                            (click)="openWindowWithButton(p)"
                                            ngbTooltip="Действия">
                                            <svg-icon class="" src="/assets/images/icons/actions-more.svg" [stretch]="true"
                                            [svgStyle]="{'width.px':20, 'height.px':20}"><i class="bi bi-three-dots-vertical"></i> </svg-icon>
                                        </button>
                                    </section> -->
    
                                </div>

                                <!-- btn edit atribute
                                <button type="button" class="btn btn-light" (click)="onEdit(attribute.id)" *ngIf="attribute.commercial"
                                    placement="top" ngbTooltip="{{ 'EDIT' | translate }}">
                                    <i class="bi bi-pencil-square"></i>
                                </button>

                                btn delete atribute
                                <button type="button" class="btn btn-light" (click)="deleteOneAttr(attribute.id)" *ngIf="attribute.commercial"
                                    placement="top" ngbTooltip="{{ 'DELETE' | translate }}">
                                    <i class="bi bi bi-trash"></i>
                                </button> -->

                                <i class="bi bi bi-info-circle ml-1" *ngIf="!attribute.commercial" placement="top" tooltipClass="clue-name" ngbTooltip="Данный атрибут является дефолтным"></i>
                                    
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="!attributes || attributes.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="10">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="10">
                                <div>{{ 'NO_DATA' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="card-footer">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div>
        </div>

    </div>
</div>